// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"styles_tooltip__tDyka","custom-tip":"styles_custom-tip__iwFLZ"};